<template>
  <div class="settingslinks">
    <f-card class="f-card-double-padding">
      <div class="small-container">
        <!-- <p> -->
        <!--   <a href="https://corexchain.io/how-to-use-corex-wallet/" target="_blank"> -->
        <!--     How to use Corex fWallet -->
        <!--   </a> -->
        <!-- </p> -->

        <p>
          <a href="https://explorer.corexchain.io/" target="_blank">
            Corexchain Explorer
          </a>
        </p>

        <social-media-links />
      </div>
    </f-card>
  </div>
</template>

<script>
import SocialMediaLinks from '@/components/SocialMediaLinks/SocialMediaLinks.vue';
import FCard from '@/components/core/FCard/FCard.vue';

export default {
  name: 'SettingsLinks',

  components: { FCard, SocialMediaLinks },
};
</script>
